import papa from 'papaparse'
import _ from 'lodash'
import { additionalFamilyTypes } from '@messenger/utils'

const parseFile = async (rawFile) => {
  return new Promise((resolve) => {
    papa.parse(rawFile, {
      skipEmptyLines: true,
      dynamicTyping: true,
      header: true,
      complete: (results) => {
        resolve(results)
      },
    })
  })
}

export const importCaseCSV = async (file) => {
  const results = await parseFile(file)

  const { data } = results

  const object = _.mapKeys(data[0], (value, key) => {
    return _.snakeCase(key)
  })

  if (!object.deceaseds_name) {
    return caseParse(object)
  } else {
    return srsParse(object)
  }
}

export default importCaseCSV

const caseParse = (object) => {
  // Collates services and stores them on newCase variable
  const service1 = object.service_1_date && {
    default: object.service_1_default && object.service_1_default,
    date: object.service_1_date && object.service_1_date,
    location: object.service_1_location && object.service_1_location,
    time: object.service_1_time && object.service_1_time,
    type: object.service_1_type && object.service_1_type,
  }
  const service2 = object.service_2_date && {
    default: object.service_2_default && object.service_2_default,
    date: object.service_2_date && object.service_2_date,
    location: object.service_2_location && object.service_2_location,
    time: object.service_2_time && object.service_2_time,
    type: object.service_2_type && object.service_2_type,
  }
  const service3 = object.service_3_date && {
    default: object.service_3_default && object.service_3_default,
    date: object.service_3_date && object.service_3_date,
    location: object.service_3_location && object.service_3_location,
    time: object.service_3_time && object.service_3_time,
    type: object.service_3_type && object.service_3_type,
  }
  const service4 = object.service_4_date && {
    default: object.service_4_default && object.service_4_default,
    date: object.service_4_date && object.service_4_date,
    location: object.service_4_location && object.service_4_location.join(','),
    time: object.service_4_time && object.service_4_time,
    type: object.service_4_type && object.service_4_type,
  }
  object.services = []
  if (service1) {
    object.services.push(service1)
  }
  if (service2) {
    object.services.push(service2)
  }
  if (service3) {
    object.services.push(service3)
  }
  if (service4) {
    object.services.push(service4)
  }

  // Collates additional_family and stores them on newCase variable

  const family1 = object.family_1_name && {
    name: object.family_1_name && object.family_1_name,
    relation: object.family_1_relation && object.family_1_relation,
    type: object.family_1_type && object.family_1_type,
  }
  const family2 = object.family_2_name && {
    name: object.family_2_name && object.family_2_name,
    relation: object.family_2_relation && object.family_2_relation,
    type: object.family_2_type && object.family_2_type,
  }
  const family3 = object.family_3_name && {
    name: object.family_3_name && object.family_3_name,
    relation: object.family_3_relation && object.family_3_relation,
    type: object.family_3_type && object.family_3_type,
  }
  const family4 = object.family_4_name && {
    name: object.family_4_name && object.family_4_name,
    relation: object.family_4_relation && object.family_4_relation,
    type: object.family_4_type && object.family_4_type,
  }
  const family5 = object.family_5_name && {
    name: object.family_5_name && object.family_5_name,
    relation: object.family_5_relation && object.family_5_relation,
    type: object.family_5_type && object.family_5_type,
  }
  object.additional_family = []
  if (family1) {
    object.additional_family.push(family1)
  }
  if (family2) {
    object.additional_family.push(family2)
  }
  if (family3) {
    object.additional_family.push(family3)
  }
  if (family4) {
    object.additional_family.push(family4)
  }
  if (family5) {
    object.additional_family.push(family5)
  }

  Object.keys(object).map((key) => {
    arrayValues.forEach((arrayValue) => {
      if (key === arrayValue) {
        object[key] =
          typeof object[key] === 'string' ? object[key].split(', ') : []
      }
    })
    // Convert migrated array fields to additional_family entries
    if (migratedArrayFields[key]) {
      const values =
        typeof object[key] === 'string' ? object[key].split(', ') : []
      values.forEach((name) => {
        if (name) {
          object.additional_family.push({
            name: name.trim(),
            type: migratedArrayFields[key],
          })
        }
      })
      delete object[key]
    }
    if (key.includes('service_')) {
      delete object[key]
    }
    if (key.includes('family_')) {
      delete object[key]
    }
    //handle empty columns
    if (key === '') delete object[key]
    return key
  })

  return object
}

const srsParse = (object) => {
  const children = [],
    music = [],
    siblings = [],
    organizations = [],
    pallbearers = [],
    clergy = [],
    service = {}

  Object.keys(object).map((key) => {
    if (key.includes('child')) {
      if (object[key]) {
        children.push(object[key])
      }
      delete object[key]
    }
    if (key.includes('music')) {
      if (object[key]) {
        music.push(object[key])
      }
      delete object[key]
    }
    if (key.includes('song')) {
      delete object[key]
    }
    if (key.includes('sibling')) {
      if (object[key]) {
        siblings.push(object[key])
      }
      delete object[key]
    }
    if (key.includes('organization')) {
      if (object[key]) {
        organizations.push(object[key])
      }
      delete object[key]
    }
    if (key.includes('pallbearer')) {
      if (object[key]) {
        pallbearers.push(object[key])
      }
      delete object[key]
    }
    if (key.includes('clergy')) {
      if (object[key]) {
        clergy.push(object[key])
      }
      delete object[key]
    }
    if (key.includes('firing_party')) {
      delete object[key]
    }
    if (key.includes('station')) {
      delete object[key]
    }
    if (key.includes('medals_other')) {
      delete object[key]
    }
    if (key.includes('rendered')) {
      delete object[key]
    }
    if (key.includes('user_defined')) {
      delete object[key]
    }
    if (key.includes('case_number')) {
      object[key] = object[key]?.toString()
    }
    if (key.includes('service_')) {
      if (key !== 'service_number' && !key.includes('cross')) {
        const path = key.split('_')[1]
        if (object[key]) service[path] = object[key]
        delete object[key]
      }
    }
    //handle empty columns
    if (key === '') delete object[key]
    return key
  })
  if (!object.additional_family) object.additional_family = []
  children.forEach((name) => {
    object.additional_family.push({
      name,
      type: additionalFamilyTypes.children,
    })
  })
  object.songs = music
  siblings.forEach((name) => {
    object.additional_family.push({
      name,
      type: additionalFamilyTypes.siblings,
    })
  })
  clergy.forEach((name) => {
    object.additional_family.push({ name, type: additionalFamilyTypes.clergy })
  })
  object.organizations = organizations
  object.pallbearers = pallbearers
  if (Object.keys(service).length > 0)
    object.services = [{ ...service, type: 'service' }]

  delete object.age
  delete object.age_months
  delete object.age_years
  delete object.age_days
  delete object.departure_date
  delete object.departure_place
  delete object.return_date
  delete object.return_place

  return renameKeys(object, srs_keys)
}

function renameKeys(obj, newKeys) {
  const keyValues = Object.keys(obj).map((key) => {
    const newKey = newKeys[key] || key
    return { [newKey]: obj[key] }
  })
  return Object.assign({}, ...keyValues)
}

const srs_keys = {
  case_number: 'editable_case_id',
  deceaseds_father: 'father_of_deceased',
  deceaseds_mother: 'mother_of_deceased',
  deceaseds_name: 'name_of_deceased',
  obit: 'obituary',
}

const arrayValues = ['organizations', 'songs', 'pallbearers']

const migratedArrayFields = {
  children: additionalFamilyTypes.children,
  siblings: additionalFamilyTypes.siblings,
  clergy: additionalFamilyTypes.clergy,
}
